import postRequest from 'utils/postRequest'
import getRequest from 'utils/getRequest'
import deleteRequest from 'utils/deleteRequest'
import putRequest from 'utils/putRequest'
import patchRequest from 'utils/patchRequest'
import filterNullAndUndefinedFieldsFromObject from 'utils/filterNullAndUndefinedFieldsFromObject'

const path = '/api/site-threat'
const reassessmentPath = '/api/reassessment/sites'

//eslint-disable-next-line
export const requestCreateSiteThreat = (siteId, siteHistoryId, {Level2ThreatId, Level3ThreatId}) => {
  const preBody = {
    Level3ThreatId,
    Level2ThreatId
  }

  const body = filterNullAndUndefinedFieldsFromObject(preBody)
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/threats` : `${path}/${siteId}`
  return postRequest(url, body)
}

export const requestGetSiteThreats = (siteId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/threats` : `${path}/${siteId}`
  return getRequest(url)
}

export const requestDeleteSiteThreat = (siteThreatId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/threats/${siteThreatId}` : `${path}/${siteThreatId}`
  return deleteRequest(url)
}

export const requestUpdateSiteThreat = (siteThreatId, siteHistoryId, { Level3ThreatId, Level2ThreatId, SiteThreatTimingId }) => {

  const preBody = {
    Level3ThreatId,
    Level2ThreatId,
    SiteThreatTimingId
  }
  
  const body = filterNullAndUndefinedFieldsFromObject(preBody)

  if (siteHistoryId){
    return patchRequest(`${reassessmentPath}/${siteHistoryId}/threats/${siteThreatId}`, body)
  }
  return putRequest(`${path}/${siteThreatId}`, body)
}
